import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { idAdded } from '../redux/books/actions';
import addBook from '../redux/books/thunk/addBook';
import updateBook from '../redux/books/thunk/updateBook';
import handleInput from '../utils/handleInput';

const BookForm = () => {
  const { items, bookToUpdate } = useSelector((state) => state.books);

  const originalBook = items.find((book) => book.id === bookToUpdate);

  let initialState = {
    name: '',
    author: '',
    thumbnail: '',
    price: '',
    rating: '',
    featured: false,
  };

  const [bookData, setBookData] = useState(initialState);

  useEffect(() => {
    if (originalBook) {
      setBookData(originalBook);
    }
  }, [originalBook]);

  const dispatch = useDispatch();
  const { name, author, thumbnail, price, rating, featured } = bookData;

  const handleChange = (e) => {
    const inputValue = handleInput(e);

    setBookData((prevBookData) => {
      return {
        ...prevBookData,
        [e.target.name]: inputValue,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (originalBook) {
      dispatch(updateBook(originalBook.id, bookData));
      dispatch(idAdded(null));
    } else {
      dispatch(addBook(bookData));
    }

    setBookData(initialState);
  };

  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
        <form className="book-form" onSubmit={handleSubmit}>
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              value={name}
              onChange={handleChange}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              value={author}
              onChange={handleChange}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              value={thumbnail}
              onChange={handleChange}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                name="price"
                value={price}
                onChange={handleChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                value={rating}
                onChange={handleChange}
                min="1"
                max="5"
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              id="input-Bookfeatured"
              type="checkbox"
              name="featured"
              checked={featured}
              onChange={handleChange}
              className="w-4 h-4"
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              {' '}
              This is a featured book{' '}
            </label>
          </div>

          <button type="submit" className="submit" id="submit">
            {originalBook ? 'Update Book' : 'Add Book'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BookForm;
